import { useSelector } from 'react-redux';
import { isBeginner as isBeginnerAction } from '../state';

function Conditional({
  beginner,
  children,
}: {
  beginner: boolean;
  children: React.ReactNode;
}) {
  const title = typeof window === 'undefined' ? '' : window?.location.pathname;
  const isBeginner = useSelector(isBeginnerAction(title));

  if (isBeginner === !!beginner) {
    // yes, the current mode is beginner
    return children;
  }
  return null;
}

export default Conditional;
